import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const LoopSheetsLanding = lazy(() => import('@/pages/members/LoopSheet/LoopSheetsLanding'))
const LoopSheetPage = lazy(() => import('@/pages/members/LoopSheet/LoopSheetPage'))


export const quantRoutes = [
  {
    path: 'quant',
    children: [
      {
        path: 'sheets',
        children: [
          {
            index: true,
            element: <LoopSheetsLanding />
          },
          {
            path: 'editor',
            element: <LoopSheetPage />
          },
          {
            path: 'editor/:workbookId',
            element: <LoopSheetPage />
          }
        ]
      }
    ]
  }
]
